import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c85dee34")

_pushScopeId("data-v-c85dee34")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "col flex-1 content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_page_header = _resolveComponent("el-page-header")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.treeData.length > 1)
      ? (_openBlock(), _createBlock(_component_el_tree, {
          key: 0,
          class: "filter-tree content",
          data: _ctx.treeData,
          props: _ctx.defaultProps,
          "default-expand-all": "",
          onNodeClick: _ctx.handleNodeClick,
          ref: "tree"
        }, null, 8, ["data", "props", "onNodeClick"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_page_header, {
        class: "padding-bottom-10",
        onBack: _ctx.goBack,
        content: "章节内容"
      }, null, 8, ["onBack"]),
      _createVNode("iframe", {
        class: "flex-1 content",
        src: _ctx.currentNode.contentUrl,
        ref: "iframe"
      }, null, 8, ["src"])
    ])
  ]))
})